(function () {
  function allowTextInteraction(el) {
    var n = el;
    while (n && n.nodeType !== 1) n = n.parentElement;
    if (!n || !n.closest) return false;
    return !!n.closest('input, textarea, select, [contenteditable="true"]');
  }

  // 整页拦截右键/长按菜单（含 H5 长按图片、div 背景图），表单内除外
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (allowTextInteraction(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'copy',
    function (e) {
      if (!allowTextInteraction(e.target)) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'cut',
    function (e) {
      if (!allowTextInteraction(e.target)) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'selectstart',
    function (e) {
      if (!allowTextInteraction(e.target)) e.preventDefault();
    },
    true
  );

  var style = document.createElement('style');
  style.setAttribute('data-disable-content-actions', '');
  style.textContent =
    'html{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;}' +
    'input,textarea,select,[contenteditable="true"]{-webkit-user-select:text;user-select:text;-webkit-touch-callout:default;}' +
    'img,picture,svg,video,canvas{-webkit-touch-callout:none!important;-webkit-user-drag:none;user-drag:none;}';
  document.head.appendChild(style);
})();
